import { Observable } from 'rxjs'

import { BaseModel } from '../../models'

/**
 * Abstract strategy class that will  contain shared functionality among backends
 * It is intended to serve as an interface + shared functionality
 */
export abstract class BackendStrategy<T extends BaseModel> {

  public abstract findById(type: string, id: string, includes?: string[]): Observable<T>

  public abstract findBy(type: string, searchCriteria: any, includes?: string[]): Observable<any[]>

  public abstract save(model: T[] | T): Observable<any> | Observable<any[]>

  public abstract delete(modelsJson: T[]): Observable<T[]>
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/backend-strategy.ts